<template>
  <v-app id="content">
    <v-app-bar class="my__toolbar" flat clipped-left dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-layout align-center justify-center>
        <v-avatar size="35">
          <v-img :src="require('../assets/icon_ondivan_white.svg')" alt="Ondivan"></v-img>
        </v-avatar>
      </v-layout>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" class="primary nav-bar" app temporary dark>
      <v-list>
        <v-list-item
          v-for="item in items"
          :key="item.title"
          @click="goPage(item.link)"
          active-class="withe--text"
        >
          <v-list-item-icon>
            <v-img
              v-if="item.img"
              :src="require(`../assets/${item.img}.png`)"
              max-width="28"
              max-height="28"
            ></v-img>
            <v-icon v-else size="28">{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="title">{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="goHelp">
          <v-list-item-icon class="icon__help mr-1">
            <v-icon size="28">help</v-icon>
          </v-list-item-icon>

          <v-list-item-content class="btn__help">
            <v-list-item-title class="text-center">Precisa de ajuda?</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="goConfig">
          <v-list-item-icon class="mr-3">
            <!-- <v-icon size="28">settings</v-icon> -->
            <v-img
              :src="require('../assets/icon_ondivan_white.svg')"
              max-width="28"
              max-height="28"
            ></v-img>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="title">Ondivan</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item class="exit-content">
          <v-dialog v-model="dialog" persistent max-width="290">
            <template v-slot:activator="{ on }">
              <v-btn class="exit-button" block text v-on="on">
                <v-icon left size="28">exit_to_app</v-icon>Sair
              </v-btn>
            </template>
            <v-card>
              <v-card-title class="headline">Sair</v-card-title>
              <v-card-text>Deseja realmente sair?</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="gray darken-1" text @click="dialog = false">Cancelar</v-btn>
                <v-btn color="secondary darken-1" text @click="getOut">OK</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-list-item>
      </v-list>
      <!-- <template v-slot:append>
                <div class="pa-2">
                    <v-btn block text @click="getOut">
                        <v-icon left size="28">exit_to_app</v-icon>
                        Sair
                    </v-btn>
                </div>
      </template>-->
      <template v-slot:append> </template>
    </v-navigation-drawer>

    <v-content app>
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
import i18n from '../plugins/i18n';

export default {
  data: () => ({
    drawer: false,
    dialog: false,
    items: [
      {
        title: 'Home',
        icon: 'home',
        link: 'DashboardPsicologo',
      },
      {
        title: 'Minha Agenda',
        icon: 'calendar_today',
        link: 'Schedule',
      },
      {
        title: 'Pacientes',
        img: 'speaking_white',
        link: 'HistoricoPacientes',
      },
      {
        title: i18n.t('navBar.coupon'),
        icon: 'fas fa-ticket-alt',
        link: 'cupom',
      },
      {
        title: i18n.t('psiFinancial.title'),
        icon: 'monetization_on',
        link: 'FinanceiroPsicologo',
      },
      {
        title: 'Perfil',
        icon: 'person',
        link: 'ProfilePsicologo',
      },
    ],
  }),
  methods: {
    getOut() {
      localStorage.clear();
      this.$router.replace('/psicologo/login');
    },
    goHelp() {
      this.$router.push('/psicologo/help');
    },
    goConfig() {
      this.$router.push('/psicologo/config');
    },
    goPage(path) {
      this.$router.push({ name: path });
    },
  },
};
</script>

<style lang="css" scoped>
#content {
  overflow-y: unset !important;
}
.title {
  line-height: normal !important;
}
.btn__help {
  background-color: #f7f7f7;
  color: #6f6f6f;
  border-radius: 20px;
}
.icon__help {
  min-width: 38px;
}
* >>> .v-navigation-drawer .v-list {
  background: inherit;
}
.my__toolbar {
  background: #93291e;
  background: linear-gradient(
    180deg,
    rgba(145, 20, 8, 1) 0%,
    rgba(158, 12, 12, 1) 50%,
    rgba(181, 27, 27, 1) 100%
  );
}
.exit-content {
  padding: 0;
  margin-top: 50px;
}
.exit-button {
  height: 58px !important;
}
@media screen and (max-width: 768px) {
  .exit-content {
    margin-top: 5px;
  }
}
</style>
